export { withSizeL } from './_size/Menu_size_l';
